import axios  from 'axios';
import { Config }   from './configActions';
var Authorization = axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem("jwtToken");
Config();
export const FETCH_RANCKING_TOP        = 'FETCH_RANCKING_TOP';
export const FETCH_RANCKING_TURMAS     = 'FETCH_RANCKING_TURMAS';
export const FETCH_RANCKING_TURMAS_TOP = 'FETCH_RANCKING_TURMAS_TOP';
export const FETCH_RANCKING_BADGE      = 'FETCH_RANCKING_BADGE';
export const FETCH_ACTION_BADGE      = 'FETCH_ACTION_BADGE';

// inicio
export function GetRanckingTop(usu_id,cur_id){
   const request = axios.get(`/api/pontuacao/ranking/top/${usu_id}/${cur_id}`,Authorization);  
   return{
        type    : FETCH_RANCKING_TOP,
        payload : request
    };
}

export function GetRanckingTurmasTop(tur_id){
   const request = axios.get(`/api/pontuacao/top/turmas/${tur_id}`,Authorization);  
   return{
        type    : FETCH_RANCKING_TURMAS_TOP,
        payload : request
    };
}

export function GetRanckingTurmas(cur_id){
   const request = axios.get(`/api/pontuacao/ranking/turmas/${cur_id}`,Authorization);  
   return{
        type    : FETCH_RANCKING_TURMAS,
        payload : request
    };
}

export function GetBadge(usu_id,cur_id){
  const request = axios.get(`/api/badges/usuario/${usu_id}/${cur_id}`,Authorization);  
   return{
        type    : FETCH_RANCKING_BADGE,
        payload : request
    };
}

export function serActionBadge(bad_id,tur_id){
    return dispatch => {

       return axios.get(`/api/badges/principal/${bad_id}/${tur_id}`,Authorization);  
    
    };
}




// WEBPACK FOOTER //
// ./src/actions/talentosAction.js